import React, {ReactElement, ReactNode} from "react";
import classNames from "classnames";


import {ButtonProps} from "../Button"


import {useLocalStorageState} from "../../hooks/useLocalStorageState";
import {CloseIcon} from "../icons/CloseIcon";


import "./Callout.css"


export interface CalloutProps {
    icon?: ReactNode,
    text: ReactNode,
    button?: ReactElement<ButtonProps>,
    className?: string
    type: "info" | "ai" | "warning" | "danger" | "success"
    onClose?: () => void;
}

export const Callout = (
    (
        {
            icon,
            text,
            button,
            className,
            type,
            onClose
        }: CalloutProps
    ) => (
        <div className={classNames({
            "Callout": true,
            "Callout--ai": type === 'ai',
            "Callout--info": type === 'info',
            "Callout--warning": type === 'warning',
            "Callout--danger": type === 'danger',
            "Callout--success": type === 'success',
            [className!]: className
        })}>
            {icon &&
                <div className="Callout__icon">
                    {icon}
                </div>
            }
            <div className="Callout__text body-large">
                {text}
                {button &&
                    <div className="Callout__button">
                        {button}
                    </div>
                }
            </div>
            {onClose && (
                <CloseIcon className="Callout__closeIcon" size={20} onClick={onClose}/>
            )}
        </div>
    )
)

interface CalloutWithStorageProps extends Omit<CalloutProps, "onClose"> {
    storageKey: string;
}

export const CalloutWithStorage = (
    ({storageKey, ...rest}: CalloutWithStorageProps) => {
        const [isHidden, setIsHidden] = useLocalStorageState(storageKey, false);

        if (isHidden) {
            return null;
        }

        return (
            <Callout
                {...rest}
                onClose={() => setIsHidden(true)}
            />
        );
    }
)
